import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "relative z-10 max-w-full mx-auto px-4 sm:px-6 lg:px-8 flex flex-col justify-center mx-auto" }
const _hoisted_2 = { class: "mx-auto mb-12 max-w-2xl text-center sm:mb-16" }
const _hoisted_3 = { class: "mx-auto grid w-full max-w-(--ui-container) grid-cols-1 gap-4 sm:gap-5 md:grid-cols-2 lg:grid-cols-4 lg:gap-6" }
const _hoisted_4 = { class: "flex flex-col gap-4 sm:gap-5 lg:gap-6 md:col-span-2 lg:col-span-2" }
const _hoisted_5 = { class: "anim-bubble absolute -top-3 right-8 flex items-center gap-1.5 rounded-full bg-gray-900 px-3 py-1.5 text-[11px] font-semibold text-white shadow-lg dark:bg-white dark:text-gray-900" }
const _hoisted_6 = { class: "flex h-3.5 w-3.5 items-center justify-center rounded-full bg-emerald-400 text-white" }
const _hoisted_7 = { class: "mt-5 flex-1" }
const _hoisted_8 = { class: "relative h-full min-h-40 overflow-hidden rounded-xl bg-gray-50 dark:bg-slate-900" }
const _hoisted_9 = { class: "absolute inset-0 bg-indigo-500 dark:bg-indigo-700" }
const _hoisted_10 = { class: "mx-auto flex h-full w-full max-w-[360px] flex-col justify-center gap-3.5" }
const _hoisted_11 = { class: "flex items-center gap-4" }
const _hoisted_12 = { class: "flex size-14 shrink-0 items-center justify-center rounded-full bg-white/20 text-white" }
const _hoisted_13 = { class: "flex flex-wrap gap-2" }
const _hoisted_14 = { class: "mx-auto flex h-full w-full max-w-[360px] flex-col justify-center gap-3.5" }
const _hoisted_15 = { class: "flex items-center gap-4" }
const _hoisted_16 = { class: "flex size-14 shrink-0 items-center justify-center rounded-full bg-indigo-950/10 text-indigo-950" }
const _hoisted_17 = { class: "flex flex-wrap gap-2" }
const _hoisted_18 = { class: "relative mt-1" }
const _hoisted_19 = { class: "relative flex items-center justify-between px-1" }
const _hoisted_20 = { class: "text-[10px] font-semibold text-indigo-950/70" }
const _hoisted_21 = { class: "mt-5" }
const _hoisted_22 = { class: "flex items-center justify-between" }
const _hoisted_23 = { class: "flex items-center gap-1.5 text-[11px] font-semibold text-gray-600 dark:text-gray-300" }
const _hoisted_24 = { class: "mt-2.5 space-y-2" }
const _hoisted_25 = {
  class: "anim-row flex items-center gap-2",
  style: {"animation-delay":"0.4s"}
}
const _hoisted_26 = { class: "flex h-4 w-4 items-center justify-center rounded-full bg-emerald-400 text-white" }
const _hoisted_27 = {
  class: "anim-row flex items-center gap-2",
  style: {"animation-delay":"0.65s"}
}
const _hoisted_28 = { class: "flex h-4 w-4 items-center justify-center rounded-full bg-purple-400 text-white" }
const _hoisted_29 = { class: "flex flex-col gap-4 sm:gap-5 lg:gap-6 lg:col-span-1" }
const _hoisted_30 = { class: "mt-5" }
const _hoisted_31 = { class: "flex h-7 w-full gap-1.5" }
const _hoisted_32 = { class: "mt-3 flex items-center gap-1.5 text-[11px] font-medium text-gray-500 dark:text-gray-400" }
const _hoisted_33 = { class: "mt-5 flex flex-1 items-center justify-center" }
const _hoisted_34 = { class: "grid w-fit grid-cols-4 gap-2" }
const _hoisted_35 = { class: "flex flex-col gap-4 sm:gap-5 lg:gap-6 lg:col-span-1" }
const _hoisted_36 = { class: "flex flex-1 items-center pt-8" }
const _hoisted_37 = { class: "mx-auto w-fit space-y-3" }
const _hoisted_38 = {
  key: 0,
  class: "shrink-0 rounded-full bg-purple-50 px-2 py-0.5 text-[10px] font-medium text-purple-600 dark:bg-purple-900/30 dark:text-purple-300"
}

import { Motion, animate, useScroll, useSpring, useTransform } from "motion-v";

// ObsScore.vue evaluation scale — same segments, colors and icons, so the
// mini view reads as the real scoring component (spring + layout included).
const cardBase = "relative flex h-full flex-col rounded-2xl bg-white p-6 dark:bg-slate-800";
const titleCls = "text-lg font-semibold text-gray-900 dark:text-white";
const descCls = "text-sm leading-relaxed text-gray-500 dark:text-gray-400";

export default /*@__PURE__*/_defineComponent({
  __name: 'FeaturesBento',
  setup(__props) {

const scoreSegments = [
  {
    value: 0,
    label: "Safeguarding",
    icon: "i-heroicons-shield-exclamation",
    color: "var(--ui-error)",
  },
  {
    value: 25,
    label: "High Support",
    icon: "i-heroicons-exclamation-triangle",
    color: "var(--ui-group_red)",
  },
  {
    value: 50,
    label: "Developing",
    icon: "i-heroicons-arrow-trending-up",
    color: "var(--ui-group_orange)",
  },
  { value: 75, label: "Achieved", icon: "i-heroicons-check-badge", color: "var(--ui-group_green)" },
  { value: 100, label: "Impactful", icon: "i-heroicons-trophy", color: "var(--ui-success)" },
];

// Cycle the selected segment like a demo of the real selector.
const activeSeg = ref(0);
let cycleTimer: ReturnType<typeof setInterval> | null = null;

onMounted(() => {
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
  cycleTimer = setInterval(() => {
    activeSeg.value = (activeSeg.value + 1) % scoreSegments.length;
  }, 2000);
});

onUnmounted(() => {
  if (cycleTimer) clearInterval(cycleTimer);
});

// Session heatmap mock — palette mirrors DirectWorkHeatmap.vue exactly:
// gray = no sessions, emerald = 1..6+ sessions, indigo = upcoming days,
// purple = assessment start / end. Cells start neutral gray and fill one by
// one, day after day.
const heatColors = [
  "bg-gray-200 dark:bg-gray-800", // 0 sessions
  "bg-emerald-200 dark:bg-emerald-900", // 1 session
  "bg-emerald-400 dark:bg-emerald-700", // 2-3 sessions
  "bg-emerald-600 dark:bg-emerald-500", // 4-5 sessions
  "bg-emerald-800 dark:bg-emerald-300", // 6+ sessions
  "bg-indigo-200 dark:bg-indigo-800", // upcoming days
  "bg-purple-400 dark:bg-purple-600", // assessment start / end
];
const heatCells = [
  { c: 6, d: 0.3 }, // assessment start
  { c: 1, d: 2 }, // 1 session
  { c: 2, d: 3.5 },
  { c: 3, d: 5 },
  { c: 1, d: 6.5 },
  { c: 2, d: 8 },
  { c: 3, d: 9.5 },
  { c: 4, d: 11 }, // 6+ sessions
  { c: 2, d: 12.5 },
  { c: 4, d: 14 },
  { c: 0, d: 15.5 }, // quiet day — stays gray
  { c: 3, d: 17 },
  { c: 4, d: 18.5 },
  { c: 5, d: 20 }, // upcoming
  { c: 5, d: 21.5 }, // upcoming
  { c: 6, d: 23.3 }, // assessment end
];

// Task list mock — status icons/colors mirror useTask statusOptions, priority
// badges mirror TaskRowLite.vue (signal icons + priority palette).
const tasks = [
  {
    status: "completed",
    statusIcon: "ri:progress-8-line",
    statusColor: "text-blue-500",
    priorityIcon: "i-mdi:signal-cellular-3",
    priorityCls: "bg-amber-400 dark:bg-[#b07a45]",
    bar: "w-24 bg-gray-200 dark:bg-slate-700",
    tag: "Weekly",
  },
  {
    status: "in_review",
    statusIcon: "hugeicons:progress-04",
    statusColor: "text-green-500",
    priorityIcon: "i-mdi:signal-cellular-2",
    priorityCls: "bg-pink-100 dark:bg-[#7f79b8]",
    bar: "w-20 bg-gray-200 dark:bg-slate-700",
  },
  {
    status: "in_progress",
    statusIcon: "hugeicons:progress-03",
    statusColor: "text-amber-500",
    priorityIcon: "i-mage:exclamation-square-fill",
    priorityCls: "bg-group_rose dark:bg-[#b35c5c]",
    bar: "w-16 bg-gray-200 dark:bg-slate-700",
  },
  {
    status: "pending",
    statusIcon: "hugeicons:progress-01",
    statusColor: "text-muted",
    priorityIcon: "i-mdi:signal-cellular-1",
    priorityCls: "bg-indigo-200 dark:bg-[#6b86a8]",
    bar: "w-24 bg-gray-200 dark:bg-slate-700",
  },
  {
    status: "pending",
    statusIcon: "hugeicons:progress-01",
    statusColor: "text-muted",
    priorityIcon: "i-mdi:signal-cellular-2",
    priorityCls: "bg-pink-100 dark:bg-[#7f79b8]",
    bar: "w-20 bg-gray-200 dark:bg-slate-700",
  },
];

// Cinematic profile reveal — a flat yellow circle expands from the centre and
// the child profile content is revealed directly inside it, over the flat
// indigo resident scene. Contracting the circle brings the resident back.
// Flat hues of the real pages (indigo resident top card, yellow child header).
const residentChips = ["Observations", "Direct work", "Court-ready reports"];
const childChips = ["Life story", "Notes & milestones", "Wishes & feelings"];
const childMilestones = ["Start", "In review", "Ready"];

const childCircle = ref<HTMLElement | null>(null);

let disposed = false;
const wait = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

onMounted(() => {
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
  runProfileCinematic();
});

onUnmounted(() => {
  disposed = true;
});

async function runProfileCinematic() {
  const cc = childCircle.value;
  if (!cc) return;

  const reveal = "circle(75% at 50% 50%)";
  const hidden = "circle(0% at 50% 50%)";
  const ease = [0.22, 1, 0.36, 1];

  while (!disposed) {
    // Child circle collapsed — resident scene on stage
    animate(cc, { clipPath: hidden }, { duration: 0 });
    await wait(2400);
    if (disposed) return;

    // Yellow circle expands — child content is revealed directly inside it
    await animate(cc, { clipPath: reveal }, { duration: 1, ease });
    await wait(2400);
    if (disposed) return;

    // Contract — the resident scene comes back into view
    await animate(cc, { clipPath: hidden }, { duration: 0.8, ease: [0.65, 0, 0.62, 1] });
  }
}

// Scroll-driven entrance — one progress value drives the whole grid, linked
// to the SECTION's scroll position: 0 when the section enters the viewport,
// 1 when 80% of the section is visible (offset "20% start" = the section's
// 20%-height point crosses the viewport top). Each card reveals inside its
// own sub-range of that progress, so the cascade finishes exactly when the
// section is 80% on screen.
const sectionEl = ref<HTMLElement | null>(null);
const { scrollYProgress } = useScroll({
  target: sectionEl,
  offset: ["start end", "20% start"],
});
const progress = useSpring(scrollYProgress, { stiffness: 220, damping: 42, mass: 0.3 });

function useScrollReveal(config: {
  range: [number, number];
  x?: [number, number];
  y?: [number, number];
  scale?: [number, number];
  rotate?: [number, number];
}) {
  const { range, ...transform } = config;
  return {
    opacity: useTransform(progress, range, [0, 1]),
    x: useTransform(progress, range, transform.x ?? [0, 0]),
    y: useTransform(progress, range, transform.y ?? [0, 0]),
    scale: useTransform(progress, range, transform.scale ?? [1, 1]),
    rotate: useTransform(progress, range, transform.rotate ?? [0, 0]),
  };
}

const residentReveal = useScrollReveal({ range: [0, 0.5], y: [48, 0], scale: [0.94, 1] });
const obsReveal = useScrollReveal({ range: [0.05, 0.55], x: [-60, 0] });
const tasksReveal = useScrollReveal({ range: [0.1, 0.6], x: [60, 0] });
const staffReveal = useScrollReveal({ range: [0.15, 0.7], y: [60, 0] });
const directReveal = useScrollReveal({ range: [0.2, 0.8], scale: [0.85, 1] });
const reportsReveal = useScrollReveal({ range: [0.15, 0.7], y: [50, 0], rotate: [-2, 0] });


return (_ctx: any,_cache: any) => {
  const _component_UIcon = _resolveComponent("UIcon")!

  return (_openBlock(), _createElementBlock("section", {
    ref_key: "sectionEl",
    ref: sectionEl,
    class: "relative w-full bg-violet-200 py-20 sm:py-24 dark:bg-violet-950 h-screen"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(Motion), {
          initial: { opacity: 0, y: 24 },
          "while-in-view": { opacity: 1, y: 0 },
          viewport: { once: true },
          transition: { duration: 0.6, ease: [0.22, 1, 0.36, 1] }
        }, {
          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
            _createElementVNode("h2", { class: "text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl dark:text-white" }, " Everything your team needs, in one place ", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_unref(Motion), {
          initial: { opacity: 0, y: 16 },
          "while-in-view": { opacity: 1, y: 0 },
          viewport: { once: true },
          transition: { duration: 0.5, ease: 'easeOut', delay: 0.15 }
        }, {
          default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
            _createElementVNode("p", { class: "mt-4 text-base text-gray-500 sm:text-lg dark:text-gray-400" }, " Profiles, observations, direct work, tasks, staff and reporting — built around the way care teams actually work. ", -1)
          ]))]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_unref(Motion), {
            style: _normalizeStyle({
              opacity: _unref(residentReveal).opacity,
              y: _unref(residentReveal).y,
              scale: _unref(residentReveal).scale,
            }),
            class: "group flex-[3]"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: _normalizeClass([cardBase, "p-6 sm:p-8"])
              }, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("span", _hoisted_6, [
                    _createVNode(_component_UIcon, {
                      name: "i-heroicons-check",
                      class: "h-2 w-2"
                    })
                  ]),
                  _cache[2] || (_cache[2] = _createTextVNode(" Profile complete ", -1))
                ]),
                _cache[8] || (_cache[8] = _createElementVNode("h3", { class: "text-xl font-semibold text-gray-900 sm:text-2xl dark:text-white" }, " Resident & Child Profiles ", -1)),
                _createElementVNode("p", {
                  class: _normalizeClass([descCls, "mt-3 max-w-md"])
                }, " A dedicated space for every parent and child — their journey, needs and progress in one place. "),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, [
                          _createElementVNode("div", _hoisted_12, [
                            _createVNode(_component_UIcon, {
                              name: "i-heroicons-user",
                              class: "size-7"
                            })
                          ]),
                          _cache[3] || (_cache[3] = _createElementVNode("div", { class: "min-w-0 flex-1" }, [
                            _createElementVNode("p", { class: "text-[10px] font-bold uppercase tracking-widest text-indigo-100" }, " Resident profile "),
                            _createElementVNode("p", { class: "mt-1 text-base font-semibold text-white" }, " The whole journey in one place ")
                          ], -1))
                        ]),
                        _createElementVNode("div", _hoisted_13, [
                          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(residentChips, (chip) => {
                            return _createElementVNode("span", {
                              key: chip,
                              class: "rounded-full bg-white/15 px-3 py-1 text-[11px] font-semibold text-white"
                            }, _toDisplayString(chip), 1)
                          }), 64))
                        ]),
                        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "flex items-center gap-3" }, [
                          _createElementVNode("div", { class: "relative h-1.5 flex-1 overflow-hidden rounded-full bg-white/25" }, [
                            _createElementVNode("div", {
                              class: "absolute inset-y-0 left-0 w-full origin-left rounded-full bg-white",
                              style: {"transform":"scaleX(0.62)"}
                            })
                          ]),
                          _createElementVNode("span", { class: "w-9 text-right text-xs font-bold text-white tabular-nums" }, "62%")
                        ], -1))
                      ])
                    ]),
                    _createElementVNode("div", {
                      ref_key: "childCircle",
                      ref: childCircle,
                      class: "absolute inset-0 bg-yellow-400 dark:bg-amber-500",
                      style: {"clip-path":"circle(0% at 50% 50%)"}
                    }, [
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("div", _hoisted_15, [
                          _createElementVNode("div", _hoisted_16, [
                            _createVNode(_component_UIcon, {
                              name: "i-heroicons-heart",
                              class: "size-7"
                            })
                          ]),
                          _cache[5] || (_cache[5] = _createElementVNode("div", { class: "min-w-0 flex-1" }, [
                            _createElementVNode("p", { class: "text-[10px] font-bold uppercase tracking-widest text-indigo-950/70" }, " Child profile "),
                            _createElementVNode("p", { class: "mt-1 text-base font-semibold text-indigo-950" }, " Their voice, their story ")
                          ], -1))
                        ]),
                        _createElementVNode("div", _hoisted_17, [
                          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(childChips, (chip) => {
                            return _createElementVNode("span", {
                              key: chip,
                              class: "rounded-full bg-indigo-950/10 px-3 py-1 text-[11px] font-semibold text-indigo-950"
                            }, _toDisplayString(chip), 1)
                          }), 64))
                        ]),
                        _createElementVNode("div", _hoisted_18, [
                          _cache[7] || (_cache[7] = _createElementVNode("svg", {
                            class: "absolute inset-x-0 top-1/2 h-px w-full -translate-y-1/2 overflow-visible text-indigo-950/25",
                            preserveAspectRatio: "none",
                            viewBox: "0 0 100 1",
                            "aria-hidden": "true"
                          }, [
                            _createElementVNode("line", {
                              x1: "0",
                              y1: "0.5",
                              x2: "100",
                              y2: "0.5",
                              stroke: "currentColor",
                              "stroke-width": "1"
                            })
                          ], -1)),
                          _createElementVNode("div", _hoisted_19, [
                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(childMilestones, (m) => {
                              return _createElementVNode("span", {
                                key: m,
                                class: "flex flex-col items-center gap-1.5"
                              }, [
                                _cache[6] || (_cache[6] = _createElementVNode("span", { class: "size-2.5 rounded-full bg-indigo-950" }, null, -1)),
                                _createElementVNode("span", _hoisted_20, _toDisplayString(m), 1)
                              ])
                            }), 64))
                          ])
                        ])
                      ])
                    ], 512)
                  ])
                ])
              ])
            ]),
            _: 1
          }, 8, ["style"]),
          _createVNode(_unref(Motion), {
            style: _normalizeStyle({
              opacity: _unref(staffReveal).opacity,
              y: _unref(staffReveal).y,
            }),
            class: "group flex-[2]"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: _normalizeClass(cardBase)
              }, [
                _createElementVNode("h3", {
                  class: _normalizeClass(titleCls)
                }, "Staff Management"),
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("span", _hoisted_23, [
                      _createVNode(_component_UIcon, {
                        name: "i-heroicons-shield-check",
                        class: "h-3.5 w-3.5 text-emerald-500 dark:text-emerald-400"
                      }),
                      _cache[9] || (_cache[9] = _createTextVNode(" Safe to Work ", -1))
                    ]),
                    _cache[10] || (_cache[10] = _createElementVNode("span", {
                      class: "anim-line text-[11px] font-semibold text-emerald-600 dark:text-emerald-400",
                      style: {"animation-delay":"0.3s"}
                    }, "92%", -1))
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("span", _hoisted_26, [
                        _createVNode(_component_UIcon, {
                          name: "i-heroicons-check",
                          class: "h-2 w-2"
                        })
                      ]),
                      _cache[11] || (_cache[11] = _createElementVNode("span", { class: "h-2 flex-1 rounded-full bg-gray-200 dark:bg-slate-700" }, null, -1)),
                      _cache[12] || (_cache[12] = _createElementVNode("span", { class: "rounded-full bg-emerald-50 px-1.5 py-0.5 text-[9px] font-medium text-emerald-600 dark:bg-emerald-900/40 dark:text-emerald-300" }, "Verified", -1))
                    ]),
                    _createElementVNode("div", _hoisted_27, [
                      _createElementVNode("span", _hoisted_28, [
                        _createVNode(_component_UIcon, {
                          name: "i-heroicons-check",
                          class: "h-2 w-2"
                        })
                      ]),
                      _cache[13] || (_cache[13] = _createElementVNode("span", { class: "h-2 flex-1 rounded-full bg-gray-200 dark:bg-slate-700" }, null, -1)),
                      _cache[14] || (_cache[14] = _createElementVNode("span", { class: "rounded-full bg-purple-50 px-1.5 py-0.5 text-[9px] font-medium text-purple-600 dark:bg-purple-900/40 dark:text-purple-300" }, "Supervision", -1))
                    ]),
                    _cache[15] || (_cache[15] = _createElementVNode("div", {
                      class: "anim-row flex items-center gap-2",
                      style: {"animation-delay":"0.9s"}
                    }, [
                      _createElementVNode("span", { class: "h-4 w-4 rounded-full border-2 border-amber-400" }),
                      _createElementVNode("span", { class: "h-2 flex-1 rounded-full bg-gray-200 dark:bg-slate-700" }),
                      _createElementVNode("span", { class: "rounded-full bg-amber-50 px-1.5 py-0.5 text-[9px] font-medium text-amber-600 dark:bg-amber-900/40 dark:text-amber-300" }, "Due Fri")
                    ], -1)),
                    _cache[16] || (_cache[16] = _createElementVNode("div", {
                      class: "anim-row flex items-center gap-2",
                      style: {"animation-delay":"1.15s"}
                    }, [
                      _createElementVNode("span", { class: "h-4 w-4 rounded-full border-2 border-gray-300 dark:border-slate-600" }),
                      _createElementVNode("span", { class: "h-2 flex-1 rounded-full bg-gray-200 dark:bg-slate-700" }),
                      _createElementVNode("span", { class: "rounded-full bg-gray-100 px-1.5 py-0.5 text-[9px] font-medium text-gray-500 dark:bg-slate-800 dark:text-gray-400" }, "Review")
                    ], -1))
                  ])
                ]),
                _createElementVNode("p", {
                  class: _normalizeClass([descCls, "mt-auto pt-4"])
                }, " Training, supervisions and safe-to-work requirements — with the documentation managed in one place. ")
              ])
            ]),
            _: 1
          }, 8, ["style"])
        ]),
        _createElementVNode("div", _hoisted_29, [
          _createVNode(_unref(Motion), {
            style: _normalizeStyle({
              opacity: _unref(obsReveal).opacity,
              x: _unref(obsReveal).x,
            }),
            class: "group flex-[2] w-full"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: _normalizeClass(cardBase)
              }, [
                _createElementVNode("h3", {
                  class: _normalizeClass(titleCls)
                }, "Observations"),
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("div", _hoisted_31, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(scoreSegments, (seg, i) => {
                      return _createVNode(_unref(Motion), {
                        key: seg.label,
                        class: _normalizeClass(["relative h-full rounded-md", _unref(activeSeg) === i ? 'shadow-sm' : 'opacity-60']),
                        style: _normalizeStyle({
                      backgroundColor: seg.color,
                      flex: _unref(activeSeg) === i ? '1 1 100%' : '0 0 1.25rem',
                    }),
                        layout: true,
                        transition: { type: 'spring', stiffness: 400, damping: 30 }
                      }, {
                        default: _withCtx(() => [
                          (_unref(activeSeg) === i)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 0,
                                class: "absolute inset-0 flex items-center justify-center truncate px-2 text-[11px] font-semibold",
                                style: _normalizeStyle({ color: seg.value >= 75 ? 'rgb(15 23 42)' : 'white' })
                              }, _toDisplayString(seg.label), 5))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1032, ["class", "style"])
                    }), 64))
                  ]),
                  _createElementVNode("div", _hoisted_32, [
                    _cache[17] || (_cache[17] = _createElementVNode("span", null, "Evaluation Rating:", -1)),
                    _createVNode(_component_UIcon, {
                      name: scoreSegments[_unref(activeSeg)].icon,
                      class: "h-3.5 w-3.5",
                      style: _normalizeStyle({ color: scoreSegments[_unref(activeSeg)].color })
                    }, null, 8, ["name", "style"]),
                    _createElementVNode("span", null, _toDisplayString(scoreSegments[_unref(activeSeg)].label), 1)
                  ])
                ]),
                _createElementVNode("p", {
                  class: _normalizeClass([descCls, "mt-auto pt-4"])
                }, " Log detailed observations with customisable templates and build a reliable, court-ready record over time. ")
              ])
            ]),
            _: 1
          }, 8, ["style"]),
          _createVNode(_unref(Motion), {
            style: _normalizeStyle({
              opacity: _unref(directReveal).opacity,
              scale: _unref(directReveal).scale,
            }),
            class: "group flex-[3]"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: _normalizeClass(cardBase)
              }, [
                _createElementVNode("h3", {
                  class: _normalizeClass(titleCls)
                }, "Direct Work"),
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("div", _hoisted_34, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(heatCells, (cell, i) => {
                      return _createElementVNode("div", {
                        key: i,
                        class: "relative h-8 w-8 overflow-hidden rounded-md bg-gray-200 dark:bg-gray-800"
                      }, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["anim-heat absolute inset-0", heatColors[cell.c]]),
                          style: _normalizeStyle({ animationDelay: `${cell.d}s` })
                        }, null, 6)
                      ])
                    }), 64))
                  ])
                ]),
                _createElementVNode("p", {
                  class: _normalizeClass([descCls, "mt-auto pt-4"])
                }, " Record one-to-one sessions with families and capture the impact of your work. ")
              ])
            ]),
            _: 1
          }, 8, ["style"])
        ]),
        _createElementVNode("div", _hoisted_35, [
          _createVNode(_unref(Motion), {
            style: _normalizeStyle({
              opacity: _unref(tasksReveal).opacity,
              x: _unref(tasksReveal).x,
            }),
            class: "group flex-[3]"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: _normalizeClass(cardBase)
              }, [
                _createElementVNode("h3", {
                  class: _normalizeClass(titleCls)
                }, "Tasks"),
                _createElementVNode("p", {
                  class: _normalizeClass([descCls, "mt-3"])
                }, " Create and assign tasks with automatic recurring schedules, so nothing slips. "),
                _createElementVNode("div", _hoisted_36, [
                  _createElementVNode("div", _hoisted_37, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(tasks, (task, i) => {
                      return _createElementVNode("div", {
                        key: i,
                        class: "anim-task flex items-center gap-2.5",
                        style: _normalizeStyle({ animationDelay: `${i * 0.4}s` })
                      }, [
                        _createVNode(_component_UIcon, {
                          name: task.statusIcon,
                          class: _normalizeClass([task.statusColor, "size-5 shrink-0"])
                        }, null, 8, ["name", "class"]),
                        _createElementVNode("span", {
                          class: _normalizeClass(["flex size-5 shrink-0 items-center justify-center rounded", task.priorityCls])
                        }, [
                          _createVNode(_component_UIcon, {
                            name: task.priorityIcon,
                            class: "size-3"
                          }, null, 8, ["name"])
                        ], 2),
                        _createElementVNode("span", {
                          class: _normalizeClass(["h-2 rounded-full", task.bar])
                        }, null, 2),
                        (task.tag)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_38, _toDisplayString(task.tag), 1))
                          : _createCommentVNode("", true)
                      ], 4)
                    }), 64))
                  ])
                ])
              ])
            ]),
            _: 1
          }, 8, ["style"]),
          _createVNode(_unref(Motion), {
            style: _normalizeStyle({
              opacity: _unref(reportsReveal).opacity,
              y: _unref(reportsReveal).y,
              rotate: _unref(reportsReveal).rotate,
            }),
            class: "group flex-[2]"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: _normalizeClass(cardBase)
              }, [
                _createElementVNode("h3", {
                  class: _normalizeClass(titleCls)
                }, "Reports"),
                _createElementVNode("p", {
                  class: _normalizeClass([descCls, "mt-3"])
                }, " Turn data into insight and export comprehensive, court-ready reports in a click. "),
                _cache[18] || (_cache[18] = _createElementVNode("div", { class: "relative mt-6 flex-1" }, [
                  _createElementVNode("div", { class: "anim-doc absolute -bottom-12 right-4 w-44 rounded-lg bg-white p-3.5 shadow-xl ring-1 ring-gray-200 dark:bg-slate-900 dark:ring-slate-700" }, [
                    _createElementVNode("div", { class: "h-2.5 w-28 rounded-full bg-gray-900/80 dark:bg-white/80" }),
                    _createElementVNode("div", { class: "mt-2.5 space-y-1.5" }, [
                      _createElementVNode("div", { class: "h-1.5 w-full rounded-full bg-gray-200 dark:bg-slate-700" }),
                      _createElementVNode("div", { class: "h-1.5 w-4/5 rounded-full bg-gray-100 dark:bg-slate-800" }),
                      _createElementVNode("div", { class: "h-1.5 w-3/5 rounded-full bg-gray-100 dark:bg-slate-800" })
                    ]),
                    _createElementVNode("div", { class: "mt-3 flex items-end gap-1" }, [
                      _createElementVNode("div", { class: "h-4 w-2.5 rounded-sm bg-purple-200 dark:bg-purple-800" }),
                      _createElementVNode("div", { class: "h-6 w-2.5 rounded-sm bg-purple-300 dark:bg-purple-700" }),
                      _createElementVNode("div", { class: "h-5 w-2.5 rounded-sm bg-purple-400 dark:bg-purple-600" }),
                      _createElementVNode("div", { class: "h-7 w-2.5 rounded-sm bg-purple-500 dark:bg-purple-500" })
                    ])
                  ])
                ], -1))
              ])
            ]),
            _: 1
          }, 8, ["style"])
        ])
      ])
    ])
  ], 512))
}
}

})